import { render } from "./Signup.vue?vue&type=template&id=32015f7c&scoped=true&lang=pug"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=32015f7c&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32015f7c"]])

export default __exports__